import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';
import Sticky from 'react-stickynode';

const EMPTY_IMAGE = 'http://api.sniffers.co.nz/wp-content/uploads/';

export default class SidebarAds extends Component {
  render() {
    const stickyTop = Theme.navigation.height * 1.5;
    const bottomBoundary = window.height - 500;

    const ads = this.props.ads;

    if(!ads.left_sidebar_ad_link || !ads.left_sidebar_ad_link.length || !ads.right_sidebar_ad_link || !ads.right_sidebar_ad_link.length || ads.left_sidebar_ad_link === EMPTY_IMAGE || ads.right_sidebar_ad_link === EMPTY_IMAGE) {
      return false;
    }

    return (
      <div className={css(styles.container)}>
        <Sticky enabled={true} top={stickyTop} bottomBoundary={bottomBoundary}>
          <a href={ads.left_sidebar_ad_link} target="_blank" className={css(styles.ad, styles.left_ad)}>
            <img src={ads.left_sidebar_ad_image} className={css(styles.image)} />
          </a>
        </Sticky>
        <Sticky enabled={true} top={stickyTop} bottomBoundary={bottomBoundary}>
          <a href={ads.right_sidebar_ad_link} target="_blank" className={css(styles.ad, styles.right_ad)}>
            <img src={ads.right_sidebar_ad_image} className={css(styles.image)} />
          </a>
        </Sticky>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    [Theme.small_screen_query]: {
      display: 'none',
    },
    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  ad: {
    position: 'absolute',
    width: 160,
    height: 600,
    backgroundColor: 'transparent',
    zIndex: 100,
  },
  left_ad: {
    left: -100,
  },
  right_ad: {
    right: -100,
  },
  image: {},
})



// WEBPACK FOOTER //
// ./src/components/SidebarAds/index.js